import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ScenarioSectionProp } from ".";


const DivisionSection = (props: ScenarioSectionProp) => {


    const { t } = useTranslation();
    const { data } = props;

    return (
        <div className="section-wrapper">


            <Row gutter={[16, 10]}>
                <Col span={24} className="form-list-item">
                    <Form.Item
                        label={t("Scenario.lbExperienceScenarioEvent")}
                    >
                    </Form.Item>
                </Col>

                {
                    data.scenario_event_experiences && data.scenario_event_experiences.map((item, index) => (
                        <Col key={index} span={24} className="form-list-item">
                            <Form.Item
                            >
                                <span>{item.division?.name} - {item.business_unit?.name} - {item.svp?.name}</span>
                            </Form.Item>
                        </Col>
                    ))
                }
            </Row>


            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbYouBelieveScenarioevent")}>
                        <span></span>
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default DivisionSection;